export default __webpack_public_path__ + "static/media/technicalApparel.bb1ed0df.png";